import * as React from 'react';
import styles from './index.less';
import { FI18n } from '@freelog/tools-lib';
import FIcons from '@/components/FIcons';

export interface FPodcastRssImportingBannerProps {
  className?: string;
  style?: React.CSSProperties;
}

function FPodcastRssImportingBanner({ className = '', style }: FPodcastRssImportingBannerProps) {
  return (
    <div className={[styles.banner, className].join(' ')} style={style}>
      <FIcons.FLoading className={styles.icon} />
      <span className={styles.text}>
        {
          // 正在导入您的播客信息，可能需要一些时间。处理完成后，您可以前往合集资源编辑页完成发布。
          FI18n.i18nNext.tAuto('submitpodcastwrss_msg_processing')
        }
      </span>
    </div>
  );
}

export default FPodcastRssImportingBanner;
